"use strict";

var _interopRequireDefault = require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AppMain", {
  enumerable: true,
  get: function get() {
    return _AppMain.default;
  }
});
Object.defineProperty(exports, "Navbar", {
  enumerable: true,
  get: function get() {
    return _Navbar.default;
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function get() {
    return _Settings.default;
  }
});
Object.defineProperty(exports, "Sidebar", {
  enumerable: true,
  get: function get() {
    return _index.default;
  }
});
Object.defineProperty(exports, "TagsView", {
  enumerable: true,
  get: function get() {
    return _index2.default;
  }
});
var _AppMain = _interopRequireDefault(require("./AppMain"));
var _Navbar = _interopRequireDefault(require("./Navbar"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _index = _interopRequireDefault(require("./Sidebar/index.vue"));
var _index2 = _interopRequireDefault(require("./TagsView/index.vue"));